import { observer } from 'mobx-react-lite'
import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import actionCart from '../utils/actionCart'
import axios from "axios"
import { SERVER_URL } from "../config";
import cartImage from "../images/cart.png"

export const Item = observer(({ item, classN }) => {
  const [brand, setBrand] = useState("")
  const [type, setType] = useState("")
  const [itemInBasket, setItemInBasket] = useState(false)
  const [isAuth, setIsAuth] = useState(false)
  const [isLoading, setIsLoading] = useState(true)

  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if (localStorage.getItem("user-token")?.length) {
      setIsAuth(true)
    }

    loadItem().then(() => setIsLoading(false))
    if (location.pathname === "/basket") {
      setItemInBasket(true)
    }

  }, [])

  const loadItem = async () => {
    try {
      const { data: itemInfo } = await axios.get(SERVER_URL + `/api/item/itemInfo?itemId=${item.id}`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("user-token")
        }
      })
      setItemInBasket(itemInfo.itemInBasket)
      setBrand(itemInfo.brand)
      setType(itemInfo.type)
    } catch (e) {
      console.log(e)
    }
  }

  const addToCart = async item => {
    await actionCart("add", item)
    .then((e) => e ? navigate("/login") : null)
    .then(() => setItemInBasket(true))
  }
  const removeFromCart = async item => await actionCart("remove", item).then(() => setItemInBasket(false))

  return (
    <>
      {
        isLoading
          ?
          <div key={item.id} className={classN + " card loading"}>
            <div className='loader'></div>
          </div>
          :
          <div key={item.id} className={classN + " card"}>
            <Link className='card__image-wrapper' to={`/item/${item.id}`}>
              <div className="card__image"
                style={{ background: `url(${item.img}) 50% 50%/cover` }}
              >
              </div>
            </Link>
            <Link to={`/item/${item.id}`}>
              <p className="card__item-name">
                {item.name.length < 33 ? item.name : `${item.name.substr(0, 33)}..`}
              </p>
            </Link>

            <p className="info">
              <Link to={`/brand/${item.brandId}`}>{brand.length < 22 ? brand : `${brand.substr(0, 22)}..`}</Link>
              <Link to={`/type/${item.typeId}`}>{type.length < 22 ? type : `${type.substr(0, 22)}..`}</Link>
            </p>
            <div className="card__bottom">
              <p>{item.price}₴</p>
              {
                isAuth
                  ? itemInBasket
                    ? <button onClick={() => removeFromCart(item)} className="add red"><span style={{ color: "#fff" }}>-</span><img src={cartImage} height={30} alt="" /></button>
                    : <button onClick={() => addToCart(item)} className="add"><span style={{ color: "#fff" }}>+</span><img src={cartImage} height={30} alt="" /></button>
                  : <button onClick={() => navigate("/login")} className="add"><span style={{ color: "#fff" }}>+</span><img src={cartImage} height={30} alt="" /></button>
              }
            </div>
          </div>
      }
    </>
  )
})
